import React, { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import { toastErrorMessagePopUp } from "../../utils/toastMessagePopup";
import ToastContainerComponent from "../toast/toast.component";
import Popup from "../../components/popup-modal/popup.component";
import "./mfasetting.styles.scss";
import Spinner from "react-bootstrap/Spinner";
import { connect } from "react-redux";
import { FormGroup } from "react-bootstrap";
import { createStructuredSelector } from "reselect";
import { selectMfaStatus, selectQrCodeData, selectQrCodeLoading, selectUserLoading, } from "../../redux/user/user.selector";
import { setMfaStatus, setQrCodeData, setQrCodeLoader, setUserLoader, } from "../../redux/user/user.actions";
import { getRequest, postRequest, putRequest } from "../../utils/apiCallerUtil";

const MfaSetting = (props) => {
  // toggle switch value
  const [toggleSwitchValue, setToggleSwitchValue] = useState(false);

  // qrcode token value
  const [qrTokenCode, setQrTokenCode] = useState("");

  useEffect(() => {
    // executed after first time calls mfa status api
    MfaStatus();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const startCommonSpinner = () => {
    // starts the spinner
    props.setUserLoader(true);
  };

  const stopCommonSpinner = () => {
    // stops the spinner
    props.setUserLoader(false);
  };

  const handleClose = (message) => {
    //   calls closeComponent method from props to close the modal also passes the success message
    props.setQrCodeData(null);
    props.setQrCodeLoader(false);
    props.setUserLoader(false);
    props.closeComponent(message);
  };

  const handleInputChange = (event) => {
    // toggle switch handle method, it toggles the switch value
    toggleSwitchValue ? setToggleSwitchValue(false) : setToggleSwitchValue(true);
    if (event.target.checked && !props.mfaStatus) {
      // if switch is on and mfa status is false then it calls the mfa qrcode api
      // and sets the props.qrCodeLoading flag to true
      props.setQrCodeLoader(true);
      MfaQrcode();
    } else {
      // if the switch is off then remove the previous qrcode data and remove the user token input
      props.setQrCodeData(null);
      setQrTokenCode("");
    }
  };

  const handleInputQrToken = (event) => {
    // handles the user otp input sets it in qrTokenCode useState
    setQrTokenCode(event.target.value);
  };

  const handleSubmitUser = () => {
    // handles verify button process
    // it starts the spinner and calls the mfa verify api
    startCommonSpinner();
    MfaVerifyApi();
  };

  const MfaStatus = async () => {
    // starts the spinner
    startCommonSpinner();
    props.setQrCodeData(null);
    // sets the toggle switch value
    setToggleSwitchValue(props.mfaStatus);
    // mfa status api which returns the mfa-status of the user

    let response = await getRequest("mfa/status");

    if (response.status >= 200 && response.status < 300) {
      // sets the toggle switch value according to mfa-status received (happens only once when the component is being loaded)
      setToggleSwitchValue(response.data.mfa_status);
      // sets the mfa-status value in redux state
      props.setMfaStatus(response.data.mfa_status);
    } else {
      // shows error message in toast container
      toastErrorMessagePopUp(response.data.detail);
    }

    // stops the spinner
    stopCommonSpinner();
  };

  const MfaQrcode = async () => {
    // mfa qrcode api which returns the qrcode used in authenticator app
    let response = await getRequest("mfa/qrcode");

    if (response.status >= 200 && response.status < 300) {
      // sets the qrcode data received in base64 encoding to props.qrCodeData which is used to display qrcode
      props.setQrCodeData(response.data.qrcode);
    } else {
      // shows error message in toast container
      toastErrorMessagePopUp(response.data.detail);
    }

    // sets the qrcode loading flag to false
    props.setQrCodeLoader(false);

    // Note that we do not use spinner loader as we already have a spinner in qrcode
    // so we use props.qrCodeLoading as a silent flag
  };

  const MfaVerifyApi = async () => {
    // mfa verify api which returns is_verified true or false, taking qrTokenCode enter by the user as a data and send it to server
    let data = {
      code: qrTokenCode,
    };

    let response = await postRequest("mfa/verify", data);
    if (response.status >= 200 && response.status < 300) {
      if (response.data.is_verified) {
        // if verified is true then calls the change status api
        MfaChangeStatusApi();
      } else {
        // if verified is false the shows a toast error message
        toastErrorMessagePopUp(
          "OTP verification failed, please check OTP and enter again"
        );
        // stops the spinner
        stopCommonSpinner();
      }
    } else {
      // shows error message in toast container
      toastErrorMessagePopUp(response.data.detail);
      // stops the spinner
      stopCommonSpinner();
    }
  };

  const MfaChangeStatusApi = async () => {
    // mfa change status api which changes the mfa-status of the user according to the mfa-status passed

    let data = {
      mfa_status: !props.mfaStatus,
    };

    let response = await putRequest("mfa/change-status", data);
    if (response.status >= 200 && response.status < 300) {
      // changes the mfa-status value in redux state
      props.setMfaStatus(response.data.mfa_status);
      // calls the handleClose to close the component and displays the appropriate message
      response.data.mfa_status
        ? handleClose("MFA Enabled")
        : handleClose("MFA Disabled");
    } else {
      // shows error message in toast container
      toastErrorMessagePopUp(response.data.detail);
      // stops the spinner
      stopCommonSpinner();
    }
  };

  const conditionalComponentDisplay = () => {
    // conditionally renders the html depending upon the toggle switch value and mfa status
    if (props.mfaStatus && !toggleSwitchValue) {
      // if the mfa-status is true and switch is at the off position
      return (
        <div>
          <hr className="mfa-break-line" />
          <p>
            1) Enter the OTP in the below field that is generated in google
            authenticator application for your account.
          </p>
          <p>
            2) On clicking Verify, If the entered OTP is valid MFA would be
            disabled for your account.
          </p>
          <hr className="mfa-break-line" />
          <div className="mfa-qr-token-box">
            <Form className="mfa-form-text-token-disable">
              <FormGroup>
                <Form.Control
                  onChange={(event) => handleInputQrToken(event)}
                  type="text"
                  placeholder="Enter Token"
                  value={qrTokenCode}
                />
              </FormGroup>
            </Form>
          </div>
        </div>
      );
    }
    if (toggleSwitchValue && !props.mfaStatus) {
      // if switch is in on position and mfa-status is false
      return (
        <div>
          <hr className="mfa-break-line" />
          <p>1) Use Google Authenticator to scan the QR-code</p>
          <p>
            2) Enter the OTP in the below field that is generated in your google
            authenticator application on completion of step 1
          </p>
          <p>
            3) On clicking Verify, If the entered OTP is valid MFA would be
            enabled for your account
          </p>
          <hr className="mfa-break-line" />
          <p className="mfa-qr-heeder">
            Scan the QR code and enter the received token here.
          </p>
          <div className="mfa-qr-token-box">
            {/* loads the qrcode */}
            {props.qrCodeData ? (
              <img
                className="mfa-qrcode-image"
                src={"data:image/png;base64," + props.qrCodeData}
                alt="qr code"
                height="146px"
                width="146px"
              />
            ) : (
                <div className="mfa-qrcode-image-spinner">
                  <Spinner animation="border" />
                </div>
              )}
            <Form className="mfa-form-text">
              <FormGroup>
                <Form.Control
                  onChange={(event) => handleInputQrToken(event)}
                  type="text"
                  placeholder="Enter Token"
                  value={qrTokenCode}
                />
              </FormGroup>
            </Form>
          </div>
        </div>
      );
    }
  };

  return (
    <Popup
      popupBig={true}
      // pass true for 1000px width popup or false for 800px width popup
      dualTitle={false}
      // pass true if there are two titles (blue and black) or false if only one title in black
      modalTitle="MFA Settings"
      // 1st title which is the default and gest used first
      modalTitle2={""}
      // 2nd title required to pass if only dualTitle is true, for 2nd title
      closeComponent={handleClose}
      // function called to close the popup component
      cancelButtonVisible={true}
      // cancel button visible in footer if true, if false then cancel button is not shown
      saveButtonVisible={true}
      // save button visible in footer if true, if false then save button is not shown
      saveComponent={handleSubmitUser}
      // note : if both cancel button and save button visible is false then the footer
      // will not be loaded , only the header and body will be visible
      saveButtonText="Save"
      // save button text
      saveButtonDisable={!qrTokenCode || props.userLoader || props.qrCodeLoading}
      // to disable save button
      spinnerVisible={props.userLoader}
    // for spinner visibility after save button
    >
      {/* header depends on whether mfa-status is true or false */}
      {props.mfaStatus ? (
        <p className="mfa-header">
          MFA is enable on your account, To turn it off please disable the
          below MFA status toggle
        </p>
      ) : (
          <p className="mfa-header">
            To enable MFA on your account, please enable the below MFA status
            toggle
          </p>
        )}

      {/* toggle switch form */}
      <Form
        className={
          "mfa-form-inline" +
          (!toggleSwitchValue && !props.mfaStatus
            ? " mfa-form-extra-space"
            : "") +
          (toggleSwitchValue && props.mfaStatus ? " mfa-form-extra-space" : "")
        }
      >
        <span className="mfa-toogle-title">MFA Status</span>
        {/* toggle switch */}
        <FormGroup>
          <Form.Switch
            id="custom-switch-data"
            onChange={(event) => handleInputChange(event)}
            checked={toggleSwitchValue}
            disabled={props.userLoader || props.qrCodeLoading}
          ></Form.Switch>
        </FormGroup>
      </Form>
      {/* component which we want to conditionally render */}
      {conditionalComponentDisplay()}
      <ToastContainerComponent />
    </Popup>
  );
};

const mapStateToProps = createStructuredSelector({
  // maps mfa status from redux store to props
  mfaStatus: selectMfaStatus,
  qrCodeData: selectQrCodeData,
  qrCodeLoading: selectQrCodeLoading,
  userLoader: selectUserLoading,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setMfaStatus: (status) => dispatch(setMfaStatus(status)),
    setQrCodeData: (status) => dispatch(setQrCodeData(status)),
    setQrCodeLoader: (status) => dispatch(setQrCodeLoader(status)),
    setUserLoader: (status) => dispatch(setUserLoader(status)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MfaSetting);
